import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const plTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Nazwa (małe litery, bez znaków specjalnych)',
    add: 'Dodaj',
    allowedFileTypes: 'Dozwolone typy plików',
    allowedFileTypesDescription:
      'Ogranicz dozwolone typy plików (np. obraz/*, aplikacja/pdf). Pozostaw puste, aby zezwolić na wszystkie typy.',
    allowMultipleFiles: 'Zezwalaj na wiele plików',
    amountInCents: 'Kwota w centach',
    basePrice: 'Cena podstawowa',
    bcc: 'BCC',
    brand: 'Marka',
    cc: 'CC',
    checkboxPlural: 'Pola wyboru',
    checkboxSingular: 'Pole wyboru',
    checkedByDefault: 'Domyślnie zaznaczone',
    chooseConfirmationType:
      'Wybierz, czy po przesłaniu formularza wyświetlić komunikat na stronie, czy przekierować na inną stronę.',
    condition: 'Stan',
    confirmationMessage: 'Wiadomość potwierdzająca',
    confirmationType: 'Typ potwierdzenia',
    countryPlural: 'Pola wiejskie',
    countrySingular: 'Kraj',
    creditCard: 'Karta kredytowa',
    customURL: 'Niestandardowy adres URL',
    datePlural: 'Pola daty',
    dateSingular: 'Data',
    defaultValue: 'Wartość domyślna',
    divide: 'Podziel',
    documentToLinkTo: 'Dokument, do którego należy załączyć link',
    doesNotEqual: 'Nie równa się',
    emailFrom: 'E-mail od',
    emailPlural: 'Pola e-mail',
    emailsDescription:
      'Wysyłaj niestandardowe e-maile po przesłaniu formularza. Użyj list oddzielonych przecinkami, aby wysłać tę samą wiadomość e-mail do wielu odbiorców. Aby odwołać się do wartości z tego formularza, owiń nazwę tego pola podwójnymi nawiasami klamrowymi, np. {{firstName}}. Możesz użyć symbolu wieloznacznego {{*}}, aby wyświetlić wszystkie dane, i {{*:table}}, aby sformatować je jako tabelę HTML w wiadomości e-mail.',
    emailSingular: 'E-mail',
    emailTo: 'Wyślij e-mail do',
    equals: 'Równe',
    field: 'Pole',
    fields: 'Pola',
    fieldWidth: 'Szerokość pola (w procentach)',
    hasAnyValue: 'Ma jakąkolwiek wartość',
    internalLink: 'Link wewnętrzny',
    label: 'Etykieta',
    maxFileSize: 'Maksymalny rozmiar pliku (w bajtach)',
    maxFileSizeDescription: 'Maksymalny rozmiar pliku w bajtach. Pozostaw puste bez ograniczeń.',
    message: 'Wiadomość',
    messageDescription: 'Wpisz wiadomość, która ma zostać wysłana w tym e-mailu.',
    messagePlural: 'Bloki wiadomości',
    messageSingular: 'Wiadomość',
    mimeType: 'Typ MIME',
    mimeTypePlural: 'Typy MIME',
    mimeTypeSingular: 'Typ MIME',
    multiply: 'Pomnóż',
    numberPlural: 'Pola liczbowe',
    numberSingular: 'Numer',
    optionPlural: 'Opcje',
    optionSingular: 'Opcja',
    paymentFieldPlural: 'Pola płatności',
    paymentFieldSingular: 'Płatność',
    paymentProcessor: 'Procesor płatności',
    paymentStatus: 'Stan',
    placeholder: 'Symbol zastępczy',
    priceConditions: 'Warunki cenowe',
    priceConditionsPlural: 'Warunki cenowe',
    priceConditionsSingular: 'Stan cenowy',
    radioOptions: 'Opcje atrybutów radiowych',
    radioPlural: 'Pola radiowe',
    radioSingular: 'Radia',
    redirect: 'Przekieruj',
    replyTo: 'Odpowiedz na',
    required: 'Wymagane',
    selectOptions: 'Wybierz Opcje',
    selectPlural: 'Wybierz Pola',
    selectSingular: 'Wybierz',
    statePlural: 'Pola stanowe',
    stateSingular: 'Stan',
    staticValue: 'Wartość statyczna',
    subject: 'Temat',
    submitButton: 'Etykieta przycisku Prześlij',
    subtract: 'Odejmij',
    textareaPlural: 'Pola obszaru tekstowego',
    textareaSingular: 'Obszar tekstowy',
    textPlural: 'Pola tekstowe',
    textSingular: 'Tekst',
    title: 'Tytuł',
    token: 'żeton',
    uploadCollection: 'Prześlij kolekcję',
    uploadCollectionDescription: 'Wybierz kolekcję przesyłania, w której będą przechowywane pliki',
    uploadFieldPlural: 'Prześlij pola',
    uploadFieldSingular: 'Prześlij',
    urlToRedirectTo: 'Adres URL, do którego należy przekierować',
    value: 'Wartość',
    valueOfField: 'Wartość pola',
    valueType: 'Typ wartości',
  },
}

export const pl: PluginLanguage = {
  dateFNSKey: 'pl',
  translations: plTranslations,
}
